<template>
  <v-autocomplete
      v-model="value"
      :items="items"
      item-text="name"
      item-value="uid"
      :label="label"
      :clearable="clearable"
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-product-dropdown",
  props: {
    label: VueTypes.string.def("Product"),
    model: VueTypes.string.def(""),
    groups: VueTypes.arrayOf(ProductGroupKind),
    clearable: VueTypes.bool.def(false)
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    items() {
      return RedactorUtils.getProductsByGroup(this.groups);
    }
  }
}

</script>
